import React, {Component} from 'react';
import {actions} from "../../actions";
import {connect} from "react-redux";
import Loader from 'react-loader';
import AssessmentReviewerTable from '../users/AssessmentReviewerTable'
import ArtifactScoreTable from './ArtifactScoreTable';
import AssessmentRubricDisplay from '../rubric/AssessmentRubricDisplay';
import ReviewerScoreBarChart from './ReviewerScoreBarChart';
import CriterionScoreBarChart from './CriterionScoreBarChart';
import CriterionAvgBarChart from './CriterionAvgBarChart';
import CommentList from '../reviews/CommentList';
import _ from 'lodash';
import {Card ,Grid ,CardContent, Typography, Button} from '@material-ui/core';
import {withStyles} from "@material-ui/core/styles/index";
import {ROLES, withRoles} from "../Permissions";
import {BASENAME} from "../../constants";
import {CSVLink} from "react-csv";

const styles = {
    card: {
        minWidth: 275,
        marginBottom: 15
    },
    title: {
        marginTop: 5,
        marginBottom: -2,
        fontSize: 12,
    },
    p: {
        marginBottom: 5
    },
    headertitle: {
        fontSize: 'x-large',
        color: '#000',
        backgroundColor: '#fff',
        padding: 16,
        marginBottom: -25
    }

};

let average = (array) => array.reduce((a, b) => Number(a) + Number(b)) / array.length;

class Assessment extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            data: [],
        };
        this.handleForbidden = this.handleForbidden.bind(this);
    }

    renderDownloadButton() {
        if(this.props.user.roles.includes(ROLES.ADMIN) || this.props.user.roles.includes(ROLES.ADMIN) || this.props.user.unid == this.props.form.coordinator_unid) {
            return(
                <Button variant="contained" color="secondary">
                    <CSVLink style={{'text-decoration': 'none'}} data={this.state.data}  filename={`${this.props.form.name}.csv`}>
                        Download CSV
                    </CSVLink>
                </Button>
            )
        } else {
            return(null)
        }
    }

    generateCsv(form) {
        let csvData = [];
        let headers = ['Assessment Name', 'College', 'Department', 'Program', 'Semester','Learning Outcome', 'Artifact', 'Criterion', 'Reviewer', 'Score'];
        csvData.push(headers);
        let terms = this.renderTerms(form.terms);
        form.reviewers.map(function(reviewer) {
            reviewer.artifactScores.map(function(artifactScore) {
                let artifactId = artifactScore.artifact_id;
                for(var i = 0; i < artifactScore.rubricScores.length; i++) {
                    let row = [];
                    let criterion = form.rubrics[i];
                    row.push(form.name, form.college.name, form.department.name, form.program.name, terms, form.outcome.name, artifactId, criterion.criteria_title, reviewer.display_name, artifactScore.rubricScores[i]);
                    csvData.push(row);
                }
            })
        })

        this.setState({data: csvData});
    }

    handleForbidden() {
        this.props.history.push('/forbidden');
    }

    async componentDidMount() {
        const {assessment_id} = this.props.match.params;
        let res = await fetch(BASENAME + '/api/assessment/' + assessment_id);
        if(res.status == 200) {
            let assessment = await res.json();
            let payload = assessment;

            this.props.setAssessment(payload);

            this.generateCsv(this.props.form);

            this.setState({loaded: true});
            
        } else {
            this.handleForbidden();
        }
    }

    renderTerms(terms) {
        let stringTerms =  _.map(terms, option => {
            return option.name;
        });
        let str = stringTerms.toString();
        return str.replace(/,/g, ', ');
    }

    getScore() {
        let scores = [];
        this.props.form.reviewers.map(function(reviewer){
            reviewer.artifactScores.map(function(artifactScore){
                let localScore = []
                artifactScore.rubricScores.map(function(rubricScore){
                    if(rubricScore != null && rubricScore > -1) {
                        localScore.push(rubricScore);
                    }
                })
                if(localScore.length > 0){
                    let score = localScore.reduce(function(a, b){return Number(a)+Number(b);})
                    scores.push(score);
                }
            })
        })

        if(scores.length == 0){
            return 'Not Started';
        } else {
            return average(scores).toFixed(2);
        }
    }

    getAverageCriteriaScore(){
        const totalAverageScore = this.getScore();
        const criterionNumber = this.props.reviewers[0].artifactScores[0].rubricScores.length;
        const averageCriteriaScore = (totalAverageScore/criterionNumber).toFixed(2);
        return averageCriteriaScore;
    }

    render() {
        const { classes } = this.props;
        let visible = null;
        if (this.state.loaded) {
            visible = (
                <div>
                    <div className='row'>
                        <Typography className='column' variant="h5" gutterBottom>
                            Review Assessment
                        </Typography>
                        <Typography className='column' style={{textAlign: 'right'}} variant="h5" gutterBottom>
                            <span style={{marginRight:20}}>
                                Score: {this.getScore()}
                            </span>
                            <span>
                                Average Criteria Score: {this.getAverageCriteriaScore()}
                            </span>
                            <div>
                                {this.renderDownloadButton()}
                            </div>
                        </Typography>

                    </div>
                    <div className='row'>
                        <div className='columnLeft'>
                            <Card className={classes.card}>
                                <Typography variant="h5" gutterBottom className={classes.headertitle}>
                                    Reviewers
                                </Typography>
                                <CardContent>
                                    <AssessmentReviewerTable users={this.props.form.reviewers} />
                                </CardContent>

                            </Card>
                        </div>
                        <div className='columnRight'>
                            <Card className={classes.card}>
                                <CardContent>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        Assessment Name
                                    </Typography>
                                    <Typography className={classes.p} variant="h6">
                                        {this.props.form.name}
                                    </Typography>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        College
                                    </Typography>
                                    <Typography className={classes.p} variant="h6">
                                        {this.props.form.college.name}
                                    </Typography>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        Department
                                    </Typography>
                                    <Typography className={classes.p} variant="h6">
                                        {this.props.form.department.name}
                                    </Typography>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        Program
                                    </Typography>
                                    <Typography className={classes.p} variant="h6">
                                        {this.props.form.program.name}
                                    </Typography>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        Term
                                    </Typography>
                                    <Typography className={classes.p} variant="h6">
                                        {this.renderTerms(this.props.form.terms)}
                                    </Typography>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        Outcome
                                    </Typography>
                                    <Typography className={classes.p} variant="h6">
                                        {this.props.form.outcome.name}
                                    </Typography>

                                </CardContent>
                            </Card>
                        </div>
                    </div>

                    <Card className={classes.card}>
                        <Typography variant="h5" gutterBottom className={classes.headertitle}>
                            Artifacts
                        </Typography>
                        <CardContent>
                            <div className='row' style={{paddingBottom: '20px'}}>
                                <ArtifactScoreTable changed={false} hideActions={true}/>
                            </div>
                        </CardContent>

                    </Card>

                    <Card className={classes.card}>
                        <Typography variant="h5" gutterBottom className={classes.headertitle}>
                            Rubric
                        </Typography>
                        <CardContent>
                            <div className='row' style={{paddingBottom: '20px'}}>
                                <AssessmentRubricDisplay />
                            </div>
                        </CardContent>
                    </Card>

                    <Card className={classes.card}>
                        <CardContent>
                            <Typography variant="h5" gutterBottom >
                                Comments
                            </Typography>
                            <React.Fragment>
                                <CommentList isReview={false}/>
                            </React.Fragment>
                        </CardContent>

                    </Card>

                    <div>
                    <Grid container spacing ={2}>
                    {/*    <div className='columnLeft'>*/}
                    <Grid item xs={6}>
                            <Card className={classes.card}>
                                <Typography variant="h5" gutterBottom className={classes.headertitle}>
                                    Criterion Totals
                                </Typography>
                                <CardContent>
                                    <div className='row' style={{paddingBottom: '20px'}}>
                                        <CriterionScoreBarChart/>
                                    </div>
                                </CardContent>
                            </Card>
                    </Grid>
                        {/*</div>*/}
                        <Grid item xs={6}>
                        {/*<div className='columnRight'>*/}
                            <Card className={classes.card}>
                                <Typography variant="h5" gutterBottom className={classes.headertitle}>
                                    Criterion Averages
                                </Typography>
                                <CardContent>
                                    <div className='row' style={{paddingBottom: '20px'}}>
                                        <CriterionAvgBarChart/>
                                    </div>
                                </CardContent>
                            </Card>
                        </Grid>
                        {/*</div>*/}
                    </Grid>
                    </div>
                    <div >
                        <Card className={classes.card}>
                            <Typography variant="h5" gutterBottom className={classes.headertitle}>
                                Artifact Scores Per Reviewer
                            </Typography>
                            <CardContent>
                                <div className='row' style={{paddingBottom: '20px'}}>
                                    <ReviewerScoreBarChart/>
                                </div>
                            </CardContent>
                        </Card>
                    </div>
                </div>
            )
        }

        return (
            <div>
                <Loader loaded={this.state.loaded}/>
                <br/>
                {visible}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        form: state.newAssessmentForm,
        reviewers: state.reviewers,
        artifacts: state.artifacts,
        rubrics: state.rubrics,
        courses: state.courses,
        user: state.user
    };
}

export default connect(mapStateToProps, actions)(withStyles(styles)(withRoles([ROLES.COORDINATOR,ROLES.DEPARTMENTCOORDINATOR, ROLES.ADMIN])(Assessment)));
